export default __webpack_public_path__ + "static/media/screenshot.5668094a.png";